<div class="breadcrumb-list p-20" fxLayout="row" fxLayoutAlign="start center">
    
    <div class="breadcrumb-item" fxFlex="0 1 auto"
        *ngFor="let item of breadcrumbList; let i = index"
        [class.active]="i===breadcrumbList.length-1">
        <a [routerLink]="item.path" href="{{item.path}}" *ngIf="i!==breadcrumbList.length-1">
        {{ item.name }}
        </a>
        <span *ngIf="i===breadcrumbList.length-1">{{ item.name }}</span>
    </div>
</div>